import { render, staticRenderFns } from "./Masters2020.vue?vue&type=template&id=fa9d6dd2&scoped=true"
import script from "./Masters2020.vue?vue&type=script&lang=js"
export * from "./Masters2020.vue?vue&type=script&lang=js"
import style0 from "./Masters2020.vue?vue&type=style&index=0&id=fa9d6dd2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa9d6dd2",
  null
  
)

export default component.exports